import { SolarCalcPage } from '../../../NewVersion/components/solar-calculator';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function Progress({ calcObj }: any) {
    const { useLang, useEffect, useState } = useGlobal();
    const { t } = useLang('calculatorssolarpanels');
    const { currentStep, currentPage } = calcObj;
    const [fixed, setFixed] = useState(false);
    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.addEventListener('scroll', handleScroll);
            return () => window.removeEventListener('scroll', handleScroll);
        }
    }, []);

    const handleScroll = () => {
        const htmlEl = document?.querySelector('html') as HTMLElement;
        const imgEl = document?.querySelector('.proBannerInter') as HTMLDivElement;
        const crumberEl = document?.querySelector('.crumber') as HTMLDivElement;
        const regionPopupEl = document?.querySelector('.regionPopup') as HTMLDivElement;
        if (htmlEl) {
            setFixed(htmlEl.scrollTop > imgEl?.offsetHeight + crumberEl?.offsetHeight + (regionPopupEl?.offsetHeight || 0));
        }
    };
    return (
        <div className={`progress ${css.progress} ${fixed ? 'fixed' : ''}`}>
            <div className="inner">
                <div className={`bg-lines active-step-${currentStep}`}>
                    <span className={`line1 line`}>
                        <span className="sub sub1"></span>
                        <span className="sub sub2"></span>
                    </span>
                    <span className={`line2 line`}></span>
                    <span className={`line3 line`}></span>
                </div>
                <div className={`text-box active-page-${currentPage}`}>
                    <span className="line-text">
                        {[SolarCalcPage.Step1, SolarCalcPage.Step2].includes(currentPage)
                            ? t('progress_scene')
                            : currentPage === SolarCalcPage.Step3
                            ? t('progress_appliances')
                            : currentPage === SolarCalcPage.Step4
                            ? t('progress_type')
                            : t('progress_result')}
                    </span>
                </div>
            </div>
        </div>
    );
}
